<template>
  <div class="results-displayas" aria-labelledby="results-displayas-title">
    <div class="results-displayas__inside">
      <div class="results-displayas__title" id="results-displayas-title">Display As:</div>
      <div class="results-displayas__items">
        <div class="results-displayas__item">
          <input type="radio" id="list" name="displayas" value="list" :checked="!calendarView" @click="updateCalendarView(false)">
          <label for="list" >List</label>
        </div>
        <div class="results-displayas__item">
          <input type="radio" id="calendar" name="displayas" value="calendar" :checked="calendarView" @click="updateCalendarView(true)">
          <label for="calendar">Calendar</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ResultsListDisplayOptions',
  date () {
    return {}
  },
  computed: {
    ...mapGetters({
      calendarView: 'getCalendarView',
      perPage: 'getPerPage',
      perPageCalendar: 'getPerPageCalendar',
      perPageList: 'getPerPageList',
    })
  },
  methods: {
    updateCalendarView(calendarView) {
      if(calendarView) {
        this.$store.commit('updateDatesSet', {})
        this.$store.commit('updateCurrentPage', 1)
        this.$store.commit('updatePerPage', this.perPageCalendar)
      } else {
        this.$store.commit('updatePerPage', this.perPageList)
      }
      this.$store.commit('updateCalendarView', calendarView)
      this.$parent.$emit('calendarViewChanged');

    },
  }
}
</script>